import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import type { PlayerProfileFormProps } from './types';
import { asNumber, asString, setNumber, setString } from './helpers';

export const SwimmingPlayerProfileForm: React.FC<PlayerProfileFormProps> = ({ value, onChange }) => (
  <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
    <FormControl fullWidth size="small">
      <InputLabel>Стиль</InputLabel>
      <Select
        value={asString(value.stroke)}
        label="Стиль"
        onChange={(e) => setString(value, 'stroke', e.target.value, onChange)}
      >
        <MenuItem value="freestyle">Вольный стиль</MenuItem>
        <MenuItem value="backstroke">На спине</MenuItem>
        <MenuItem value="breaststroke">Брасс</MenuItem>
        <MenuItem value="butterfly">Баттерфляй</MenuItem>
        <MenuItem value="medley">Комплекс</MenuItem>
      </Select>
    </FormControl>
    <TextField label="Дистанция (м)" size="small" value={asNumber(value.distance)} onChange={(e) => setNumber(value, 'distance', e.target.value, onChange)} />
    <TextField label="Лучшее время" size="small" value={asString(value.bestTime)} onChange={(e) => setString(value, 'bestTime', e.target.value, onChange)} />
    <TextField label="Разряд/класс" size="small" value={asString(value.classification)} onChange={(e) => setString(value, 'classification', e.target.value, onChange)} />
  </Box>
);
